import React from "react";
import { motion } from "framer-motion";
import "./../styles/about.css"
import about_top from "../images/about_top.png"
import buildin from "../images/buildin.jpg"
import ravishankar from "../images/ravishankar.png"
import Footer from "./../components/Footer"
const about = () => {
    return(
        <>
     <motion.div 
     
     className="hero-section"
               initial={{ opacity: 0, y: -50 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.5 }}
     >
        {/* ============= first about us page ===================================== */}

        <div className="about">
     
      <div className="about-left">
        <div className="about-left-img-div">
            <img className="about-top-img" src={about_top}></img>
        </div>
      </div>
      <div className="about-right">
        <div className="about-right-text">
            <h3>About Us</h3>
            <p>Who We Are</p>
            <b>We are a team of skilled engineers and professionals,</b><br></br>
            <b>dedicated to delivering top-notch ERP solutions tailored </b><br></br>
            <b> diverse business needs. With a passion for innovation </b><br></br>
            <b>  and excellence, we aim to redefine industry standards </b><br></br>
            <b> and empower businesses to thrive. </b>
        </div>
      </div>

        </div>
        {/* ============================== about second page =============================== */}
        <h2 className="about-company-heading">About Our Company</h2>
        <div className="about-company">
          <section className="about-company-left">
            <img className="left-img" src={buildin}></img>
          </section>
          <div className="about-company-right">
            <p className="about-company-right-heading">KNEWX ERP SOLUTION</p>
            <div className="about-para">
            <b>Knewx ERP Solution was founded on 1st January 2025 by Mr. Ravishankar Sharma</b><br></br>
            <b>with a strong vision to transform the way businesses manage their operations.</b><br></br>
            <b>With years of experience in technology and a deep understanding of organizational</b><br></br>
            <b> needs, Mr. Sharma aimed to create a powerful yet user-friendly ERP system that</b><br></br>
            <b>could cater to businesses of all sizes — from startups to large enterprises</b><br></br>
            <b>The mission of Knewx ERP Solution is to provide smart, scalable, and integrated</b><br></br>
            <b>software solutions that simplify complex business processes, increase efficiency,</b><br></br>
            <b>and drive growth. Since its inception, the company has been committed to innovation,</b><br></br>
            <b>reliability, and customer satisfaction, making it a trusted partner for digital</b> <br></br>
            <b>transformation in the modern business world.</b>
             </div>

          </div>
        </div>
        {/* ========================== 3rd part about founder ==================================== */}
        <section className="about-founder">
       <div className="about-founder-left">
        <h3>PROFILE</h3>
        <div className="founder-card">
  <img className="pic-founder" src={ravishankar} alt="Founder" /><br></br>
  <span className="founder-name">Mr.RAVISHANKAR SHARMA</span><br></br>
  <span className="founder-name1">FOUNDER OF</span><br></br>
  <span className="founder-name2"> KNEWX ERP SOLUTIONS</span>
</div>
       </div>
       <div className="about-founder-right">
        <span className="job-expe">JOB EXPERIENCE</span>
        <span className="exp1">
        <h5>2000 - 2007</h5>
        <p>Trainee Engineer - KIRLOSKAR DEWAS<br></br> Marketing Executive - MADI CAPS LTD PITAMPUR</p></span>
       
        <span className="exp2">
        <h5>2007 - 2010</h5>
        <p>Planning Engineer - JASH ENGINEERING INDORE<br></br></p>
        </span>

        <span className="exp3">
        <h5>2010 - 2014</h5>
       <p>Planing Enigineer AND SAP CORE TEAM <br></br>
       MEMBER - KARAMTARA ENGINEERING <br></br>
       TARAPUR, DIST.PALGHAR HO. MUMBAI</p>
       </span>

       <span className="exp4">
        <h5>2014 - 2019</h5>
       <p>Planing Head - SHAKTI PUMS INDIA <br></br>
      LIMITED, PITAMPUR </p>
       </span>
       </div>

       <div className=".about-founder-right1">
       <span className="exp5">
        <h5>2014 - 2019</h5>
       <p>Planing Head - SHAKTI PUMS INDIA 
      LIMITED, PITAMPUR </p>
       </span>

       <span className="exp6">
        <h5>2019 - 2021</h5>
       <p>Planing Head - PIX TRANSMISSION NAGPUR <br></br>Plant Head - DECG BHOPA</p>
       </span>

       <span className="exp6">
        <h5>2021 - Onwords</h5>
       <p>CREATED KAPIL NARAYAN ENGG WORK <br></br>AND GOT SUPLIES OF RAILWAYS TO<br></br> KOLKATA DURING CORONA. AND SHIFTED <br></br>TO SOFTWARE
       DEVEOPMENT FOR<br></br>INDUSTRIES AT BEST RATES AND ALL<br></br> MAJOR FUNTIONALITIES DECG INTRNATIONAL<br></br>MILK WASTE MANAGEMENT AND COUNT IS ON AS
       <br></br>WE MOVE AHEAD</p>
       </span>
       </div>
        </section>
     </motion.div>
     <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
     <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
     
     
     <Footer/>
        </>
    )
}
export default about;